export const normalizeFileNameForPDF = (fileName = '') => fileName.replace(/[^\w\d]+/g, '_');
